import { BaseProps, Dialog, DialogBody, DialogTitle } from '@/components/base/dialog'
import { AttachmentAttributes } from '@/types'
import { Form as NewForm } from './new_form'
import { DocumentNode } from '@apollo/client'

interface Props extends BaseProps {
  defaultValues: Partial<AttachmentAttributes>
  refetchQueries?: DocumentNode[]
}

export const NewDialog = ({ defaultValues, open, setOpen, refetchQueries = [] }: Props) => {
  return (
    <>
      <Dialog open={open} size="3xl" onClose={setOpen}>
        <DialogTitle>Add attachments</DialogTitle>
        <DialogBody>
          <NewForm defaultValues={defaultValues} refetchQueries={refetchQueries} onSuccess={() => setOpen(false)} />
        </DialogBody>
      </Dialog>
    </>
  )
}
